import { useEffect } from 'react';
import { useAtomValue } from 'jotai';
import CreatorOnboarding from 'src/components/Creator/CreatorOnboarding';
import useEnableRemoteConfig from 'src/hooks/useEnableRemoteConfig';
import useLogin from 'src/hooks/useLogin';
import { CreatorOnboardingStep, creatorOnboardingStepAtom } from 'src/stores/creator/atom';
import { ModalType } from 'src/types/Modal';
import getDeviceInfo from 'src/utils/device/info';
import { OrderedModalHookType } from './types';
import withLoginUserModalPromise from './withLoginUserModalPromise';
const useCreatorOnboardingModal: OrderedModalHookType = modalPropsPromise => {
  const creatorOnboardingStep = useAtomValue(creatorOnboardingStepAtom);
  const isEnableCreatorPlan = useEnableRemoteConfig('enableCreatorPlan');
  const {
    isLogin
  } = useLogin();
  useEffect(() => {
    if (!isLogin) return;
    const isCreatorPlanEnabled = isEnableCreatorPlan && !getDeviceInfo().isMobile;
    const isCreatorOnboardingCompleted = creatorOnboardingStep === CreatorOnboardingStep.Done;
    if (isCreatorPlanEnabled && !isCreatorOnboardingCompleted) {
      modalPropsPromise?.resolve([{
        modalProps: {
          key: ModalType.CREATOR_ONBOARDING,
          component: () => <CreatorOnboarding />
        }
      }]);
    } else {
      modalPropsPromise?.resolve(null);
    }
  }, [creatorOnboardingStep, isEnableCreatorPlan, isLogin, modalPropsPromise]);
};
export default withLoginUserModalPromise(useCreatorOnboardingModal);